module.exports = __webpack_public_path__ + "static/media/copy_mission_email.980e6227.svg";